import React from 'react'

import { useLabel } from '../../../../hooks/useLabel'
import SelectField from '../../../components/SelectField'

// Item da lista em opção do SelectField: `value` é o que grava, `name` o que aparece.
// { acronym, label } aparece como "CA - California" e grava "CA"
const toOption = state =>
  typeof state === 'string'
    ? { value: state, name: state }
    : { value: state.acronym, name: `${state.acronym} - ${state.label}` }

// Divisão do país (estado, departamento, província) com a lista do país. Um valor já
// gravado que não está na lista entra nas opções, para não se perder ao salvar de novo
const StateSelect = ({ value, onChange, format }) => {
  const label = useLabel()
  const options = format.states.map(toOption)
  const selected = options.find(option => option.value === value)

  if (value && !selected) options.unshift(toOption(value))

  return (
    <SelectField
      options={options}
      setForm={(name, option) => onChange(option ? option.value : null)}
      data={selected || (value ? toOption(value) : null)}
      name="uf"
      label={label('uf', 'Estado')}
    />
  )
}

export default StateSelect
